import DisabledOverlay from './DisabledOverlay';
import DisabledOverlayContainer from './DisabledOverlay.container';

export default DisabledOverlayContainer(DisabledOverlay);
